var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nowrap"},[_c('i',{staticClass:"bi bi-dash-square",on:{"click":function($event){return _vm.edit('minus')}}}),_c('i',{staticClass:"bi bi-plus-square",on:{"click":function($event){return _vm.edit('plus')}}})])}
var staticRenderFns = []

export { render, staticRenderFns }